import { useApprovalConfig } from './useApprovalConfig';
import { useApprovalData } from './useApprovalData';
import { useApprovalMeta } from './useApprovalMeta';
export const useApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  assetName,
  approvalObjectIds,
  previewSidebarContent,
  restartOnConclude
}) => {
  const approvalConfig = useApprovalConfig(approvalType, approvalAction);
  const approvalData = useApprovalData(approvalType, approvalAction, approvableObjectId, assetName, approvalObjectIds);
  const api = Object.assign({
    fetchConfig: approvalConfig.fetchConfig
  }, approvalData.api);
  const meta = useApprovalMeta({
    approvalType,
    approvalAction,
    approvableObjectId,
    assetName,
    approvalObjectIds,
    previewSidebarContent,
    restartOnConclude,
    approvalData,
    approvalConfig
  });
  return {
    api,
    data: approvalData.data,
    config: approvalConfig.config,
    meta,
    previewSidebarContent
  };
};